import regeneratorRuntime from "regenerator-runtime";
import Utilitiesjs from '../utilites';
import Ajaxjs from '../ajax';
export default class Profile {
    constructor() {
        this.running = false;
        this.utilsjs = new Utilitiesjs;
        this.ajaxjs = new Ajaxjs;
    }
    async init(provinces) {
        document.querySelectorAll("[data-tag=country]").forEach(ele => {
            ele.onchange = function () {
                var country = this.value;
                const provinceBlock = document.getElementById("d-province-block");
                const provinceEle = document.getElementById(this.dataset.bind);
                provinceEle.value = "";
                country = country === "États-Unis" ? "United States" : country;
                if (country !== "Canada" && country !== "United States") {
                    provinceEle.required = false;
                    provinceEle.hidden = true;
                    provinceBlock.hidden = true;
                    return;
                } else {
                    provinceEle.required = true;
                    provinceEle.hidden = "";
                    provinceBlock.hidden = "";
                }
                const filterProvince = [...provinces].filter(f => f.Country === country);
                const newProvinceDownlistData = filterProvince.map(province =>
                    `<option value="${province.Name}">${province.Name}</option>`);
                provinceEle.innerHTML = newProvinceDownlistData.join("");
            };
        });
        $('#EmailConfirm, #Email').on('input blur change', function(){
            var emailConfVal = $(this).parents('.cscp-form').find('#EmailConfirm').val()
            var emailVal = $(this).parents('.cscp-form').find('#Email').val()
            if (emailVal !== '' && emailConfVal !== '' && emailConfVal !== emailVal) {
                $('#profileSection .resp-block-emailconfirm .email-not-match').removeClass('d-none');
                $(this).parents('.cscp-form').find('[type="submit"]').attr('disabled', true)
            } else {
                $('#profileSection .resp-block-emailconfirm .email-not-match').addClass('d-none');
                $(this).parents('.cscp-form').find('[type="submit"]').attr('disabled', false)
            }
        })
        var $changeEmailBlock = $('.change-email-block');
        if($changeEmailBlock.length){
            $('.show-hide-change-email').click(function(){
                $('.block-links-change').addClass('d-none');
                $('.block-emails').removeClass('d-none');
            })
        }
    }
    async updateProfile(e, formId, submittingLabelId, successLabelId, failedValidateId) {
        e.preventDefault();
        var that = this;
        let button = this.utilsjs.disableButton(e);
        that.utilsjs.hideById(successLabelId);
        that.utilsjs.hideById(failedValidateId);
        that.utilsjs.showById(submittingLabelId);
        let updateStatus = await that.ajaxjs.serializeAndPostForm(formId, 'UpdateProfile', 'Member');
        if (updateStatus === '200' || updateStatus === '202') {
            $('#profileSection .resp-block-emailconfirm .email-not-match, #profileSection .resp-block-emailconfirm .email-invalid').addClass('d-none');
            if (updateStatus === '200') {
                if (await that.ajaxjs.postForm('ChangeEmailSendConfirm', 'Account', '') === '202') {
                    $('#profileSection .resp-block').removeClass('d-none');
                }
            }
            that.utilsjs.hideById(submittingLabelId);
            that.utilsjs.hideById(failedValidateId);
            that.utilsjs.showById(successLabelId);
            let modRef = document.getElementById('profileModRef').getAttribute("data-value");
            that.ajaxjs.loadPartialActionControllerQuerystringElementId('ProfileSide', 'Member', `?modRef=${modRef}&isReload=true`, 'profileSideSectionParent');
        } else {
            that.utilsjs.hideById(submittingLabelId);
            that.utilsjs.hideById(successLabelId);
            that.utilsjs.showById(failedValidateId);
            switch(updateStatus){
                case '400':
                    $('#profileSection .resp-block, #profileSection .resp-block-emailconfirm .email-invalid').addClass('d-none');
                    $('#profileSection .resp-block-emailconfirm .email-not-match').removeClass('d-none');
                    break;
                case '401':
                    $('#profileSection .resp-block, #profileSection .resp-block-emailconfirm .email-not-match').addClass('d-none');
                    $('#profileSection .resp-block-emailconfirm .email-invalid').removeClass('d-none');
                    break;
                default:
                    break;
            }
        }
        button.disabled = false;
    }
}


// WEBPACK FOOTER //
// ./Scripts/es6/controllers/profile.js